/* eslint-disable */
import * as Types from '../../../shared/__gql-types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetZonesQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type GetZonesQuery = { __typename: 'Query', getLabels: Array<{ __typename: 'Label', alias: string, name: string, id: string, country_codes: Array<string>, units: Array<{ __typename: 'Unit', id: string, alias: string, name: string }> }> };


export const GetZonesDocument = gql`
    query getZones {
  getLabels {
    alias
    name
    id
    country_codes
    units {
      id
      alias
      name
    }
  }
}
    `;

/**
 * __useGetZonesQuery__
 *
 * To run a query within a React component, call `useGetZonesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetZonesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetZonesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetZonesQuery(baseOptions?: Apollo.QueryHookOptions<GetZonesQuery, GetZonesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetZonesQuery, GetZonesQueryVariables>(GetZonesDocument, options);
      }
export function useGetZonesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetZonesQuery, GetZonesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetZonesQuery, GetZonesQueryVariables>(GetZonesDocument, options);
        }
export type GetZonesQueryHookResult = ReturnType<typeof useGetZonesQuery>;
export type GetZonesLazyQueryHookResult = ReturnType<typeof useGetZonesLazyQuery>;